// src/utils/api.js
import axios from "axios";
/**
 * Axios instance with session (cookie) support
 * - withCredentials: true 让浏览器自动带上 Cookie (sessionId)
 */
const api = axios.create({
  timeout: 5000,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export default api;
